const url = window.location.origin;
console.log(url)
export const PREFIX = `${url}`
